import { useEffect, useState } from "react";
import { Loader2, RotateCcw, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const WeightsCard = () => {
  const [items, setItems] = useState([]);
  const [def, setDef] = useState({});
  const [busy, setBusy] = useState(false);
  const load = (d) => { setItems(d.items.map((i) => ({ ...i, weight: String(i.weight) }))); setDef(d.default); };
  useEffect(() => {
    api.get("/settings/lb-weights").then((r) => load(r.data));
  }, []);

  const total = items.reduce((s, i) => s + (Number(i.weight) || 0), 0);
  const ok = Math.abs(total - 100) <= 0.1;
  const set = (k, v) => setItems(items.map((i) => (i.key === k ? { ...i, weight: v } : i)));
  const save = async (weights) => {
    setBusy(true);
    try {
      load((await api.put("/settings/lb-weights", { weights })).data);
      toast.success("Bobot peringkat disimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <div data-testid="lb-weights-card" className="rounded-xl border bg-card p-5 shadow-sm">
      <h3 className="font-heading text-lg font-semibold">Bobot Indikator Peringkat Unit</h3>
      <p className="text-sm text-muted-foreground">Skor gabungan = rata-rata berbobot capaian tiap indikator (maks 120%). Bobot 0% = indikator tidak dinilai. Total harus 100%.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((i) => (
          <label key={i.key} className="flex items-center justify-between gap-3 rounded-lg border px-3 py-2">
            <span className="text-sm font-medium">{i.label}</span>
            <span className="flex items-center gap-1">
              <Input data-testid={`lb-weight-${i.key}`} type="number" min="0" max="100" step="0.5" value={i.weight}
                onChange={(e) => set(i.key, e.target.value)} className="h-8 w-20 text-right font-num" />%
            </span>
          </label>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <span data-testid="lb-weight-total" className={`text-sm font-semibold ${ok ? "text-emerald-600" : "text-rose-600"}`}>Total: {total.toLocaleString("id-ID")}%</span>
        <Button data-testid="lb-weights-save-button" disabled={!ok || busy} onClick={() => save(Object.fromEntries(items.map((i) => [i.key, Number(i.weight)])))}>
          {busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Save className="mr-1.5 h-4 w-4" />}Simpan Bobot
        </Button>
        <Button data-testid="lb-weights-reset-button" variant="ghost" disabled={busy} onClick={() => save(def)}><RotateCcw className="mr-1.5 h-4 w-4" />Bobot Sama Rata</Button>
      </div>
    </div>
  );
};
